<crypto-crypto-list
  [cryptos]="cryptoFacade.cryptos$ | async"
  [popularCryptos]="cryptoFacade.popularCryptos$ | async"
  (scrollTo)="scrollTo($event)"
/>
<crypto-etp-list [items]="cryptoFacade.etps$ | async" />
